import React from 'react';

import './OrderStatusRenderer.scss';

export let renderOrderStatus = (status) => {
  let text = "";

  switch(status) {
    case "PENDING_APPROVAL":
      text = "Pending Approval";
      break;
    case "PENDING_AUTHORIZE":
      text = "Pending Authorize";
      break;
    case "BOOKING":
      text = "Booking";
      break;
    case "RECEIVED":
        text = "Received";
        break;  
    case "PROCESSING":
      text = "Processing";
      break;
    case "COMPLETED":
      text = "Completed";
      break;
    case "CANCELED":
      text = "Cancelled";
      break;
    case "CLOSED":
      text = "Closed";
      break;
    case "DRAFT":
      text = "Draft";
      break;
    case "RETURNED":
      text = "Returned";
      break;
    case "REJECTED":
      text = "Rejected";
      break;
    default:
      text = ""
  }

  const className = text.toLowerCase();
  return (
      <span className={`order-status-label order-status-${className}`}>{text}</span>
  )
};
